<template>
  <div>
    <div id="svgaBox"></div>
  </div>
</template>

<script>

import '@/assets/css/style.css'
import SVGA from "svgaplayerweb"
import { judgeIosAndroid } from '@/assets/js/models.js'

export default {
  data() {
    return {}
  },
  mounted() {
    // 将要给原生调用的方法挂载到 window 上面
    window.play_svga = this.play_svga
  },
  // created() {
  //   const url ="https://pw-1251470018.cos.ap-nanjing.myqcloud.com/9889aac32f3f88edb34ca4e7b1959315.svga";
  //   this.play_svga(url)
  // },
  methods: {
    svgaClose() {
        let url = 'Close'
        //  拦截
        const isIos = judgeIosAndroid();
        if (isIos === true) {
          // ios传值方法postMessage（val）传值方式
          window.webkit.messageHandlers.CloseSvga.postMessage(url)
        } else {
          // 安卓传值方式
          window.AndroidJs.CloseSvga(url)
        }
    },
    play_svga(url) {
      console.log('开始播放')
      const _this= this
      this.$nextTick(() => {
        try {
          const player = new SVGA.Player('#svgaBox');
          const parser = new SVGA.Parser('#svgaBox');
          //注意，这里必须是服务器地址，否则报错
          parser.load(url, function(videoItem) {
            player.loops = 1;  // 设置循环播放次数是1
            player.setVideoItem(videoItem);
            player.startAnimation();
            player.onFinished(function(){
              console.log('结束')
              _this.svgaClose()
            });
          })
        } catch (error) {
          console.error(error);
        }
      })
    }
  }
}
</script>

<style>
#svgaBox { height: 100vh;}
</style>



// WEBPACK FOOTER //
// src/components/play_svga.vue